import classNames from 'classnames';
import { FC, Fragment } from 'react';

import styles from './confirmModal.module.scss';

interface ConfirmModalButton {
  label: string;
  onClick: () => void;
}

interface ConfirmModalProps {
  title?: string;
  text?: string;
  buttons?: ConfirmModalButton[];
  className?: string;
}

const ConfirmModal: FC<ConfirmModalProps> = (props) => {
  const { title, text, buttons, className } = props;

  function renderButtons(item: ConfirmModalButton, index: number) {
    return (
      <Fragment key={index}>
        <button
          className={classNames(
            `button ${index > 0 ? 'button--confirm-black' : 'button--confirm-white'}`,
          )}
          onClick={item.onClick}
        >
          {item.label}
        </button>
      </Fragment>
    );
  }

  return (
    <div className={classNames(styles.container, className)}>
      {title && (
        <div className={styles.container__titleBlock}>
          <p className={styles.container__title}>{title}</p>
        </div>
      )}
      {text && (
        <div className={styles.container__textBlock}>
          <p className={styles.container__text}>{text}</p>
        </div>
      )}
      {!!buttons?.length && (
        <div className={styles.container__controls}>
          {buttons?.map(renderButtons)}
        </div>
      )}
    </div>
  );
};

export default ConfirmModal;
